import React from 'react';
import { useState } from 'react';
import '../styles/SearchBar.css';

function SearchBar({ onSearch }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!searchQuery.trim()) return;
    
    setIsSearching(true);
    onSearch(searchQuery);
    setSearchQuery('');
    
    // Reset searching state after a short delay
    setTimeout(() => setIsSearching(false), 1000);
  };

  const handleChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <section className="search-section">
      <div className="search-container">
        <div className="search-content">
          <div className="search-header">
            <h2 className="search-title">Find Your Favorite Streamers</h2>
            <p className="search-description">
              Search for Twitch creators by username to discover their latest VODs and highlights
            </p>
          </div>
          
          <form onSubmit={handleSubmit} className="search-form">
            <div className="search-input-group">
              <div className="search-input-wrapper">
                <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  id="creator-search"
                  name="creator-search"
                  value={searchQuery}
                  onChange={handleChange}
                  placeholder="Enter usernames separated by commas (e.g., jordanchude, pokimane, xqc)"
                  className="search-input"
                  disabled={isSearching}
                  aria-label="Search for Twitch creators"
                />
              </div>
              <button 
                type="submit" 
                className={`search-button ${isSearching ? 'searching' : ''}`}
                disabled={isSearching || !searchQuery.trim()}
                aria-label="Search for VODs"
              >
                {isSearching ? (
                  <>
                    <svg className="loading-icon" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Searching...
                  </>
                ) : (
                  <>
                    <svg className="search-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Get VODs
                  </>
                )}
              </button>
            </div>
            
            <div className="search-tips">
              <p className="search-tip">
                <strong>Tip:</strong> You can search for multiple creators at once by separating usernames with commas
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default SearchBar;